import React from "react";
import notfound from "../../assets/images/notfound.png";
const PageNotFound = () => {
  return (
    <div className="text-center">
      <h1>404</h1>
      <img src={notfound} alt="" />
    </div>
  );
};

export default PageNotFound;
